exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-19356981]{width:100%;color:#2f2f2f;outline:0;padding:1.5rem 1.125rem .75rem;font-size:1.125rem;font-weight:400;border-radius:.1875rem;border:1px solid #dcdada;transition:.2s ease-out;box-sizing:border-box;caret-color:#16244f;box-shadow:none;margin-bottom:1rem}input[data-v-19356981],input[data-v-19356981]:focus{background-color:#fff}input[data-v-19356981]:focus{border-color:#16244f}", ""]);

// exports
